import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { TouchInput } from "@/components/VirtualKeyboard";
import { apiErr } from "@/lib/api";
import { Sun, Moon, Languages } from "lucide-react";

const LOGO = "/lapaz-logo.png";
const LOGO_WHITE = "/lapaz-logo-white.png";

export default function Login() {
  const { login } = useAuth();
  const { t, lang, theme, toggleLang, toggleTheme } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/catalogo");
    } catch (err) {
      setError(apiErr(err, "Correo o contraseña incorrectos"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex justify-end gap-2 p-4">
        <button data-testid="login-language-toggle" onClick={toggleLang} className="h-11 px-4 rounded-xl border bg-card flex items-center gap-2 font-semibold text-sm">
          <Languages className="h-5 w-5" /> {lang === "es" ? "ES" : "EN"}
        </button>
        <button data-testid="login-theme-toggle" onClick={toggleTheme} className="h-11 w-11 rounded-xl border bg-card flex items-center justify-center">
          {theme === "light" ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="text-center mb-8 animate-fade-up">
            <img src={LOGO} alt="La Paz Internacional" className="h-16 mx-auto object-contain dark:hidden" />
            <img src={LOGO_WHITE} alt="La Paz Internacional" className="h-16 mx-auto object-contain hidden dark:block" />
            <h1 className="mt-5 font-display font-extrabold text-4xl text-primary">Appomax</h1>
            <p className="text-muted-foreground text-sm uppercase tracking-widest mt-1">{t("company")}</p>
          </div>

          <form onSubmit={submit} className="rounded-2xl border bg-card p-6 shadow-lg space-y-4 animate-fade-up">
            <div>
              <label className="text-sm font-semibold">{t("email")}</label>
              <TouchInput testId="login-email-input" value={email} onChange={setEmail} placeholder="correo@ejemplo.com" className="mt-1.5" />
            </div>
            <div>
              <label className="text-sm font-semibold">{t("password")}</label>
              <TouchInput testId="login-password-input" type="password" value={password} onChange={setPassword} placeholder="••••••••" className="mt-1.5" />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2">
                {error}
              </div>
            )}
            <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full min-h-[56px] rounded-xl text-base font-bold">
              {loading ? "..." : t("signIn")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
